import { render, staticRenderFns } from "./ErrorTip.vue?vue&type=template&id=64660330&scoped=true&"
import script from "./ErrorTip.vue?vue&type=script&lang=js&"
export * from "./ErrorTip.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTip.vue?vue&type=style&index=0&id=64660330&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64660330",
  null
  
)

export default component.exports